import { Drum, Landmark, Users, UtensilsCrossed, Music, Heart, Star, Clock } from "lucide-react";
import { SectionHeading } from "./kit";

const ICONS = { drum: Drum, culture: Landmark, community: Users, food: UtensilsCrossed, music: Music, heart: Heart, star: Star };
const ACCENTS = ["border-t-red-700", "border-t-amber-500", "border-t-emerald-700", "border-t-amber-500"];
const DAY_BG = ["bg-red-800", "bg-amber-500 text-neutral-950", "bg-emerald-800", "bg-neutral-100 text-neutral-950"];

export const Highlights = ({ content }) => (
  <section id="highlights" className="diamond-bg relative px-5 py-20 md:py-28" data-testid="highlights-section">
    <div className="mx-auto max-w-6xl">
      <SectionHeading eyebrow="The gathering" title="What to" accent="expect">
        {content.intro}
      </SectionHeading>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {(content.highlights || []).map((h, i) => {
          const Icon = ICONS[h.icon] || Star;
          return (
            <div
              key={i}
              data-testid={`highlight-card-${i}`}
              className={`group rounded-lg border border-neutral-800 border-t-4 ${ACCENTS[i % 4]} bg-neutral-900 p-6 transition-transform duration-300 hover:-translate-y-1`}
            >
              <Icon className="mb-5 h-9 w-9 text-amber-400 transition-transform duration-300 group-hover:scale-110" strokeWidth={1.5} />
              <h3 className="font-display text-xl text-neutral-50">{h.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-neutral-400">{h.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export const Schedule = ({ content }) => (
  <section id="schedule" className="bg-neutral-950 px-5 py-20 md:py-28" data-testid="schedule-section">
    <div className="mx-auto max-w-6xl">
      <SectionHeading eyebrow={content.dates_label} title="Four days" accent="of honor" />
      <ol className="grid gap-4 md:grid-cols-2">
        {(content.schedule || []).map((s, i) => {
          const [dow, date] = (s.date_label || "").split("·").map((x) => x.trim());
          return (
            <li key={s.day} data-testid={`schedule-item-${s.day}`} className="flex overflow-hidden rounded-lg border border-neutral-800 bg-neutral-900 transition-transform duration-300 hover:-translate-y-1">
              <div className={`flex w-24 shrink-0 flex-col items-center justify-center px-2 py-6 text-center ${DAY_BG[i % 4]}`}>
                <span className="font-display text-sm tracking-[0.2em] opacity-90">{dow}</span>
                <span className="font-display text-2xl font-bold leading-tight">{date || ""}</span>
              </div>
              <div className="flex-1 p-5">
                <h3 className="font-display text-2xl text-gold">{s.title}</h3>
                {s.time && (
                  <p className="mt-1 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-emerald-400">
                    <Clock className="h-3.5 w-3.5" /> {s.time}
                  </p>
                )}
                <p className="mt-2 text-sm leading-relaxed text-neutral-400">{s.description}</p>
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  </section>
);
